import {DELETE_NEWS_START} from "../../types";

export const delete_news = (payload) => ({
    type: DELETE_NEWS_START,
    payload,
});
